// import React, { useEffect, useState, useContext, useCallback, useRef } from "react";
// import axios from "axios";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import { toast } from "react-toastify";
// import { 
//   FiUser, 
//   FiMail, 
//   FiPhone, 
//   FiBriefcase, 
//   FiShield, 
//   FiCamera, 
//   FiUpload, 
//   FiTrash2,
//   FiInfo,
//   FiClock,
//   FiCheck,
//   FiMapPin,
//   FiCreditCard,
//   FiLayers
// } from "react-icons/fi";
// import ReactWebcam from "react-webcam";
// import { getAccessToken } from "../../token";

// // --- Helper Components ---

// const FormInput = ({ label, icon: Icon, ...props }) => (
//   <div className="group">
//     <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center ml-1">
//       {Icon && <Icon className="mr-2 h-4 w-4 text-[#0C4550]" />}
//       {label}
//     </label>
//     <div className="relative">
//       <input
//         {...props}
//         className={`w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#0C4550] focus:ring-2 focus:ring-[#0C4550]/10 transition-all duration-300 hover:border-[#0C4550]/30 shadow-sm ${props.disabled ? 'bg-gray-50 text-gray-500 cursor-not-allowed' : ''}`}
//       />
//     </div>
//   </div>
// );

// const StatusBadge = ({ type }) => {
//     const colors = {
//         SUPER_SUPER_ADMIN: "bg-purple-100 text-purple-700 border-purple-200",
//         SUPER_ADMIN: "bg-indigo-100 text-indigo-700 border-indigo-200",
//         COMPANY: "bg-[#0C4550]/10 text-[#0C4550] border-[#0C4550]/20",
//         RESELLER: "bg-[#A7A08F]/10 text-[#0C4550] border-[#A7A08F]/20",
//         default: "bg-gray-100 text-gray-700 border-gray-200"
//     };
//     return (
//         <span className={`px-3 py-1.5 rounded-full text-xs font-bold border ${colors[type] || colors.default}`}>
//             {type?.replace(/_/g, " ") || "USER"}
//         </span>
//     );
// };

// const DateDisplay = ({ label, date }) => {
//   if (!date) return null;
//   const formattedDate = new Date(date).toLocaleDateString('en-US', {
//     year: 'numeric',
//     month: 'short',
//     day: 'numeric'
//   });

//   return (
//     <li className="flex justify-between items-center">
//       <span className="text-gray-600">{label}</span>
//       <span className="font-bold text-gray-600 text-xs md:text-sm">{formattedDate}</span>
//     </li>
//   );
// };

// // --- Main Component ---

// const ProfilePage = () => {
//   const token = getAccessToken();
//   const { user } = useContext(AuthContext); 
//   const [userData, setUserData] = useState({});

//   const [profileImage, setProfileImage] = useState(null);
//   const [showWebcam, setShowWebcam] = useState(false);
//   const [isUploading, setIsUploading] = useState(false);
//   const webcamRef = useRef(null);

//   // --- Fetch Profile Image with Authorization ---
//   const loadProfileImage = useCallback(async (filename) => {
//     if (!filename || !token) {
//       setProfileImage(null);
//       return;
//     }

//     try {
//       const fullUrl = `${API_URL}/api/v1/users/photo/${filename}`;

//       const response = await fetch(fullUrl, {
//         headers: { 
//           'Authorization': `Bearer ${token}`,
//           'Accept': 'image/*'
//         }
//       });

//       if (!response.ok) {
//         throw new Error(`Failed to load image: ${response.status}`);
//       }

//       const blob = await response.blob();
//       const imageUrl = URL.createObjectURL(blob);
//       setProfileImage(imageUrl);

//     } catch (error) {
//       console.error("Error loading profile image:", error);
//       setProfileImage(null);
//     }
//   }, [token]);

//   // --- Clean up blob URLs ---
//   useEffect(() => {
//     return () => {
//       if (profileImage && profileImage.startsWith('blob:')) {
//         URL.revokeObjectURL(profileImage);
//       }
//     };
//   }, [profileImage]);

//   // --- Fetch Profile Logic ---
//   const fetchUserProfile = useCallback(async () => {
//     if (!token) return;

//     try {
//       const response = await fetch(`${API_URL}/api/v1/users/me`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       if (!response.ok) throw new Error("Failed to fetch");

//       const resData = await response.json();

//       if (resData.success && resData.data) {
//         const data = resData.data;
//         setUserData(data);

//         // Load photo using the exact variable name from your backend DTO
//         const photoFilename = data.profilePictureUrl; 
//         if (photoFilename) {
//           loadProfileImage(photoFilename);
//         } else {
//           setProfileImage(null); // Clear if no photo exists
//         }
//       }

//     } catch (err) {
//       console.error("Profile fetch error:", err);
//       toast.error("Could not load profile data");
//     }
//   }, [token, loadProfileImage]);

//   useEffect(() => {
//     fetchUserProfile();
//   }, [fetchUserProfile]);

//   // --- Upload Image File (Synchronous) ---
//   const handleImageUpload = async (file) => {
//     if (!file) return;

//     // Validate file type
//     if (!file.type.startsWith('image/')) {
//       toast.error("Please select an image file");
//       return;
//     }

//     // Validate file size (2MB max to match backend)
//     if (file.size > 2 * 1024 * 1024) {
//       toast.error("Image size must not exceed 2MB");
//       return;
//     }

//     setIsUploading(true);

//     // Show local preview instantly
//     const localPreview = URL.createObjectURL(file);
//     setProfileImage(localPreview);

//     const formDataUpload = new FormData();
//     formDataUpload.append('file', file);

//     try {
//       const response = await axios.post(
//         `${API_URL}/api/v1/users/photo`,
//         formDataUpload,
//         {
//           headers: {
//             'Authorization': `Bearer ${token}`,
//             'Content-Type': 'multipart/form-data'
//           }
//         }
//       );

//       // Instantly refresh profile data since the backend process is synchronous
//       if (response.data.success) {
//         toast.success("Profile picture updated successfully!");
//         fetchUserProfile(); 
//       }
//     } catch (error) {
//       console.error("Upload error:", error);
//       toast.error(error.response?.data?.message || "Failed to upload image");
//       // Revert preview on failure
//       fetchUserProfile(); 
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   // --- Upload from Webcam ---
//   const captureWebcam = useCallback(async () => {
//     const imageSrc = webcamRef.current.getScreenshot();
//     setShowWebcam(false);

//     // Convert base64 to File object
//     const blob = await (await fetch(imageSrc)).blob();
//     const file = new File([blob], "webcam-capture.jpg", { type: "image/jpeg" });

//     await handleImageUpload(file);
//   }, [webcamRef, handleImageUpload]);

//   // --- Delete Profile Picture ---
//   const handleDeleteImage = async () => {
//     if (!window.confirm("Are you sure you want to remove your profile picture?")) {
//       return;
//     }

//     try {
//       const response = await axios.delete(
//         `${API_URL}/api/v1/users/photo`,
//         {
//           headers: { Authorization: `Bearer ${token}` }
//         }
//       );

//       if (response.data.success) {
//         // Clean up blob URL
//         if (profileImage && profileImage.startsWith('blob:')) {
//           URL.revokeObjectURL(profileImage);
//         }

//         setProfileImage(null);
//         toast.success("Profile picture removed successfully!");
//         fetchUserProfile();
//       }
//     } catch (error) {
//       console.error("Delete error:", error);
//       toast.error("Failed to remove profile picture");
//     }
//   };

//   return (
//     <div className="min-h-screen bg-[#F0EFEB] font-sans p-4 md:p-6">
//       <div className="max-w-7xl mx-auto">

//         {/* Header */}
//         <div className="mb-8">
//           <div className="flex justify-between items-center">
//             <div>
//               <h1 className="text-2xl md:text-3xl font-bold text-[#0C4550]">My Profile</h1>
//               <p className="text-gray-600 mt-2">View your personal information and account security</p>
//             </div>
//             <div className="hidden md:block">
//               <StatusBadge type={userData?.role} />
//             </div>
//           </div>
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">

//           {/* LEFT COLUMN: Profile Card and Account Status (Span 4) */}
//           <div className="lg:col-span-4 space-y-6">
//             {/* Profile Card */}
//             <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100 flex flex-col items-center text-center">
//               {/* Photo Area */}
//               <div className="relative group">
//                 <div className="w-32 h-32 rounded-full border-4 border-gray-50 shadow-lg overflow-hidden bg-gray-100 flex items-center justify-center">
//                   {isUploading ? (
//                     <div className="text-gray-400 text-xs font-semibold animate-pulse">Uploading...</div>
//                   ) : profileImage ? (
//                     <img 
//                       src={profileImage} 
//                       alt="Profile" 
//                       className="w-full h-full object-cover"
//                       onError={() => setProfileImage(null)}
//                     />
//                   ) : (
//                     <FiUser className="w-16 h-16 text-gray-300" />
//                   )}
//                 </div>
//                 {/* Hover Overlay for Upload */}
//                 {!isUploading && (
//                   <label className="absolute inset-0 bg-black/40 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer text-white font-medium text-sm">
//                     <FiCamera className="mr-2" />
//                     Change Photo
//                     <input 
//                       type="file" 
//                       className="hidden" 
//                       accept="image/jpeg, image/png, image/jpg" 
//                       onChange={(e) => handleImageUpload(e.target.files[0])}
//                     />
//                   </label>
//                 )}
//               </div>

//               <h2 className="mt-4 text-xl font-bold text-gray-800">
//                 {userData.firstName} {userData.lastName}
//               </h2>
//               <p className="text-sm text-gray-500">{userData.email}</p>
//               {userData.companyName && (
//                  <p className="text-xs font-semibold text-[#0C4550] mt-1">{userData.companyName}</p>
//               )}

//               <div className="mt-6 w-full grid grid-cols-2 gap-3">
//                 <button 
//                   onClick={() => setShowWebcam(true)}
//                   disabled={isUploading}
//                   className="flex items-center justify-center gap-2 px-4 py-2.5 bg-gray-50 text-gray-600 rounded-xl text-sm font-semibold hover:bg-gray-100 transition-colors border border-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   <FiCamera /> Webcam
//                 </button>
//                 <label className="flex items-center justify-center gap-2 px-4 py-2.5 bg-[#0C4550]/5 text-[#0C4550] rounded-xl text-sm font-semibold hover:bg-[#0C4550]/10 transition-colors border border-[#0C4550]/20 cursor-pointer">
//                   <FiUpload /> Upload
//                   <input 
//                     type="file" 
//                     className="hidden" 
//                     accept="image/jpeg, image/png, image/jpg"
//                     disabled={isUploading}
//                     onChange={(e) => handleImageUpload(e.target.files[0])}
//                   />
//                 </label>
//               </div>

//               {profileImage && (
//                 <button
//                   onClick={handleDeleteImage}
//                   className="mt-4 w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-red-50 text-red-600 rounded-xl text-sm font-semibold hover:bg-red-100 transition-colors border border-red-100"
//                 >
//                   <FiTrash2 /> Remove Photo
//                 </button>
//               )}
//             </div>

//             {/* Account Status Card */}
//             <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
//               <div className="flex items-center gap-3 mb-6">
//                 <div className="w-12 h-12 bg-[#0C4550]/10 rounded-xl flex items-center justify-center">
//                   <FiInfo className="h-6 w-6 text-[#0C4550]" />
//                 </div>
//                 <div>
//                   <p className="text-xl font-bold text-gray-800">Account Status</p>
//                   <p className="text-gray-500 text-sm">Your current account information</p>
//                 </div>
//               </div>

//               <div className="space-y-4">
//                 <div className="bg-[#0C4550]/5 rounded-xl p-4 border border-[#0C4550]/10">
//                   <h4 className="font-semibold text-[#0C4550] mb-3 flex items-center gap-2">
//                     <FiCheck className="h-4 w-4" />
//                     Status & Role
//                   </h4>
//                   <ul className="space-y-3 text-sm text-[#0C4550]/80">
//                     <li className="flex justify-between items-center">
//                       <span className="text-gray-600">Active Status</span>
//                       <span className={`font-bold ${userData.active ? 'text-green-600' : 'text-red-600'}`}>
//                         {userData.active ? 'Active' : 'Inactive'}
//                       </span>
//                     </li>
//                     <li className="flex justify-between items-center">
//                       <span className="text-gray-600">Role</span>
//                       <StatusBadge type={userData?.role} />
//                     </li>
//                   </ul>
//                 </div>

//                 <div className="bg-[#C5F637]/10 rounded-xl p-4 border border-[#C5F637]/20">
//                   <h4 className="font-semibold text-[#0C4550] mb-3 flex items-center gap-2">
//                     <FiClock className="h-4 w-4" />
//                     Validity & Rates
//                   </h4>
//                   <ul className="space-y-3 text-sm text-[#0C4550]/70">
//                     <DateDisplay label="Valid From" date={userData.validFrom} />
//                     <DateDisplay label="Valid To" date={userData.validTo} />
//                     <li className="flex justify-between items-center border-t border-dashed border-[#0C4550]/20 pt-2 mt-2">
//                       <span className="text-gray-600 font-semibold">SMS Rate</span>
//                       <span className="font-bold text-[#0C4550] text-lg">
//                         {userData.smsRate ? userData.smsRate : '0.00'}
//                       </span>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT COLUMN: Details Form (Span 8) */}
//           <div className="lg:col-span-8">
//             <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
//               {/* Form Header */}
//               <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-[#0C4550]/5 to-transparent">
//                 <div className="flex items-center gap-3">
//                   <div className="w-10 h-10 rounded-xl bg-[#0C4550]/10 flex items-center justify-center">
//                     <FiBriefcase className="h-5 w-5 text-[#0C4550]" />
//                   </div>
//                   <div>
//                     <p className="text-xl font-bold text-gray-800">Profile Details</p>
//                     <p className="text-gray-500 text-sm">Your personal and company details</p>
//                   </div>
//                 </div>
//               </div>

//               {/* Form Content */}
//               <div className="p-6 md:p-8 space-y-8">

//                 {/* Section 1: Personal Info */}
//                 <div>
//                   <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
//                     <FiUser className="text-[#0C4550]" /> Personal Information
//                   </h3>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                     <FormInput 
//                       label="First Name" 
//                       value={userData.firstName || ""} 
//                       disabled
//                       icon={FiUser}
//                     />
//                     <FormInput 
//                       label="Last Name" 
//                       value={userData.lastName || ""} 
//                       disabled
//                       icon={FiUser}
//                     />
//                     <FormInput 
//                       label="Email Address" 
//                       value={userData.email || ""} 
//                       disabled 
//                       icon={FiMail}
//                     />
//                     <FormInput 
//                       label="Phone Number" 
//                       value={userData.phone || ""} 
//                       disabled
//                       icon={FiPhone}
//                     />
//                     <div className="md:col-span-2">
//                         <FormInput 
//                         label="Address" 
//                         value={userData.address || ""} 
//                         disabled
//                         icon={FiMapPin}
//                         />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="border-t border-gray-100"></div>

//                 {/* Section 2: Company Info */}
//                 <div>
//                   <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
//                     <FiBriefcase className="text-[#0C4550]" /> Company Details
//                   </h3>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                     <FormInput 
//                       label="Company Name" 
//                       value={userData.companyName || ""} 
//                       disabled
//                       icon={FiLayers}
//                     />
//                     <FormInput 
//                       label="Company Type" 
//                       value={userData.companyType || ""} 
//                       disabled
//                       icon={FiBriefcase}
//                     />
//                   </div>
//                 </div>

//                 <div className="border-t border-gray-100"></div>

//                 {/* Section 3: Legal Info */}
//                 <div>
//                   <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
//                     <FiShield className="text-[#0C4550]" /> Legal Information
//                   </h3>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                     <FormInput 
//                       label="GST Number" 
//                       value={userData.gstNumber || ""} 
//                       disabled
//                       icon={FiShield}
//                     />
//                     <FormInput 
//                       label="PAN Number" 
//                       value={userData.panNumber || ""} 
//                       disabled
//                       icon={FiCreditCard}
//                     />
//                   </div>
//                 </div>

//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Webcam Modal */}
//       {showWebcam && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
//           <div className="bg-white rounded-2xl shadow-2xl overflow-hidden max-w-lg w-full">
//             <div className="p-4 border-b border-gray-100 flex justify-between items-center">
//               <h3 className="font-bold text-gray-800">Take Photo</h3>
//               <button 
//                 onClick={() => setShowWebcam(false)} 
//                 className="text-gray-400 hover:text-gray-600 transition-colors"
//               >
//                 ✕
//               </button>
//             </div>
//             <div className="p-4 bg-black">
//               <ReactWebcam
//                 audio={false}
//                 ref={webcamRef}
//                 screenshotFormat="image/jpeg"
//                 className="rounded-lg w-full"
//                 style={{ transform: "scaleX(-1)" }} 
//               />
//             </div>
//             <div className="p-4 flex justify-center gap-4 bg-gray-50">
//               <button 
//                 onClick={() => setShowWebcam(false)} 
//                 className="px-6 py-2.5 text-sm font-semibold text-gray-600 hover:bg-gray-200 rounded-xl transition-colors"
//               >
//                 Cancel
//               </button>
//               <button 
//                 onClick={captureWebcam} 
//                 className="px-6 py-2.5 text-sm font-semibold text-white bg-[#0C4550] rounded-xl hover:bg-[#0C4550]/90 transition-colors"
//               >
//                 Capture Photo
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ProfilePage;





// import React, { useEffect, useState, useContext, useCallback, useRef } from "react";
// import axios from "axios";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import { toast } from "react-toastify";
// import {
//   FiUser,
//   FiMail,
//   FiPhone,
//   FiBriefcase,
//   FiShield,
//   FiCamera,
//   FiUpload,
//   FiTrash2,
//   FiInfo,
//   FiClock,
//   FiCheck,
//   FiMapPin,
//   FiCreditCard,
//   FiLayers,
//   FiKey,
//   FiEye,
//   FiEyeOff,
//   FiCopy,
//   FiLock
// } from "react-icons/fi";
// import ReactWebcam from "react-webcam";
// import { getAccessToken } from "../../token";

// // --- Helper Components ---

// const FormInput = ({ label, icon: Icon, ...props }) => (
//   <div className="group">
//     <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center ml-1">
//       {Icon && <Icon className="mr-2 h-4 w-4 text-[#0C4550]" />}
//       {label}
//     </label>
//     <div className="relative">
//       <input
//         {...props}
//         className={`w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#0C4550] focus:ring-2 focus:ring-[#0C4550]/10 transition-all duration-300 hover:border-[#0C4550]/30 shadow-sm ${props.disabled ? 'bg-gray-50 text-gray-500 cursor-not-allowed' : ''}`}
//       />
//     </div>
//   </div>
// );

// const StatusBadge = ({ type }) => {
//   const colors = {
//     SUPER_SUPER_ADMIN: "bg-purple-100 text-purple-700 border-purple-200",
//     SUPER_ADMIN: "bg-indigo-100 text-indigo-700 border-indigo-200",
//     COMPANY: "bg-[#0C4550]/10 text-[#0C4550] border-[#0C4550]/20",
//     RESELLER: "bg-[#A7A08F]/10 text-[#0C4550] border-[#A7A08F]/20",
//     default: "bg-gray-100 text-gray-700 border-gray-200"
//   };
//   return (
//     <span className={`px-3 py-1.5 rounded-full text-xs font-bold border ${colors[type] || colors.default}`}>
//       {type?.replace(/_/g, " ") || "USER"}
//     </span>
//   );
// };

// const DateDisplay = ({ label, date }) => {
//   if (!date) return null;
//   const formattedDate = new Date(date).toLocaleDateString('en-US', {
//     year: 'numeric',
//     month: 'short',
//     day: 'numeric'
//   });

//   return (
//     <li className="flex justify-between items-center">
//       <span className="text-gray-600">{label}</span>
//       <span className="font-bold text-gray-600 text-xs md:text-sm">{formattedDate}</span>
//     </li>
//   );
// };

// // --- Main Component ---

// const ProfilePage = () => {
//   const token = getAccessToken();
//   const { user } = useContext(AuthContext);
//   const [userData, setUserData] = useState({});

//   // Image States
//   const [profileImage, setProfileImage] = useState(null);
//   const [showWebcam, setShowWebcam] = useState(false);
//   const [isUploading, setIsUploading] = useState(false);
//   const webcamRef = useRef(null);

//   // API Key States
//   const [apiKey, setApiKey] = useState(null);
//   const [showApiKeyModal, setShowApiKeyModal] = useState(false);
//   const [passwordVerify, setPasswordVerify] = useState("");
//   const [isVerifyingPassword, setIsVerifyingPassword] = useState(false);
//   const [isApiKeyRevealed, setIsApiKeyRevealed] = useState(false);

//   // --- Fetch Profile Image with Authorization ---
//   const loadProfileImage = useCallback(async (filename) => {
//     if (!filename || !token) {
//       setProfileImage(null);
//       return;
//     }

//     try {
//       const fullUrl = `${API_URL}/api/v1/users/photo/${filename}`;
//       const response = await fetch(fullUrl, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Accept': 'image/*'
//         }
//       });

//       if (!response.ok) throw new Error(`Failed to load image: ${response.status}`);

//       const blob = await response.blob();
//       const imageUrl = URL.createObjectURL(blob);
//       setProfileImage(imageUrl);
//     } catch (error) {
//       console.error("Error loading profile image:", error);
//       setProfileImage(null);
//     }
//   }, [token]);

//   // --- Clean up blob URLs ---
//   useEffect(() => {
//     return () => {
//       if (profileImage && profileImage.startsWith('blob:')) {
//         URL.revokeObjectURL(profileImage);
//       }
//     };
//   }, [profileImage]);

//   // --- Fetch Profile Logic ---
//   const fetchUserProfile = useCallback(async () => {
//     if (!token) return;
//     try {
//       const response = await fetch(`${API_URL}/api/v1/users/me`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (!response.ok) throw new Error("Failed to fetch");
//       const resData = await response.json();
//       if (resData.success && resData.data) {
//         const data = resData.data;
//         setUserData(data);
//         const photoFilename = data.profilePictureUrl;
//         if (photoFilename) loadProfileImage(photoFilename);
//         else setProfileImage(null);
//       }
//     } catch (err) {
//       console.error("Profile fetch error:", err);
//       toast.error("Could not load profile data");
//     }
//   }, [token, loadProfileImage]);

//   useEffect(() => {
//     fetchUserProfile();
//   }, [fetchUserProfile]);

//   // --- Upload Handlers ---
//   const handleImageUpload = async (file) => {
//     if (!file) return;
//     if (!file.type.startsWith('image/')) {
//       toast.error("Please select an image file");
//       return;
//     }
//     if (file.size > 2 * 1024 * 1024) {
//       toast.error("Image size must not exceed 2MB");
//       return;
//     }

//     setIsUploading(true);
//     const localPreview = URL.createObjectURL(file);
//     setProfileImage(localPreview);

//     const formDataUpload = new FormData();
//     formDataUpload.append('file', file);

//     try {
//       const response = await axios.post(`${API_URL}/api/v1/users/photo`, formDataUpload, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'multipart/form-data'
//         }
//       });
//       if (response.data.success) {
//         toast.success("Profile picture updated successfully!");
//         fetchUserProfile();
//       }
//     } catch (error) {
//       console.error("Upload error:", error);
//       toast.error(error.response?.data?.message || "Failed to upload image");
//       fetchUserProfile();
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   const captureWebcam = useCallback(async () => {
//     const imageSrc = webcamRef.current.getScreenshot();
//     setShowWebcam(false);
//     const blob = await (await fetch(imageSrc)).blob();
//     const file = new File([blob], "webcam-capture.jpg", { type: "image/jpeg" });
//     await handleImageUpload(file);
//   }, [webcamRef, handleImageUpload]);

//   const handleDeleteImage = async () => {
//     if (!window.confirm("Are you sure you want to remove your profile picture?")) return;
//     try {
//       const response = await axios.delete(`${API_URL}/api/v1/users/photo`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       if (response.data.success) {
//         if (profileImage && profileImage.startsWith('blob:')) URL.revokeObjectURL(profileImage);
//         setProfileImage(null);
//         toast.success("Profile picture removed successfully!");
//         fetchUserProfile();
//       }
//     } catch (error) {
//       console.error("Delete error:", error);
//       toast.error("Failed to remove profile picture");
//     }
//   };

//   // --- API Key Handlers ---
//   const handleVerifyAndFetchApiKey = async (e) => {
//     e.preventDefault();
//     if (!passwordVerify) {
//       toast.error("Please enter your password");
//       return;
//     }

//     setIsVerifyingPassword(true);
//     try {
//       // 1. Verify password (You need to ensure this endpoint exists on your backend to verify the password against the current user)
//       await axios.post(`${API_URL}/api/v1/auth/verify-password`, {
//         password: passwordVerify
//       }, {
//         headers: { Authorization: `Bearer ${token}` }
//       });

//       // 2. Fetch API Key
//       const response = await axios.get(`${API_URL}/api/v1/apikeys/me`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });

//       setApiKey(response.data.apiKey);
//       setShowApiKeyModal(false);
//       setPasswordVerify("");
//       setIsApiKeyRevealed(true);
//       toast.success("API Key revealed successfully");

//     } catch (error) {
//       console.error("Verification error:", error);
//       toast.error(error.response?.data?.message || "Incorrect password or failed to fetch API key");
//     } finally {
//       setIsVerifyingPassword(false);
//     }
//   };

//   const copyToClipboard = () => {
//     if (apiKey) {
//       navigator.clipboard.writeText(apiKey);
//       toast.success("API Key copied to clipboard!");
//     }
//   };

//   return (
//     <div className="min-h-screen bg-[#F0EFEB] font-sans p-4 md:p-6">
//       <div className="max-w-7xl mx-auto">

//         {/* Header */}
//         <div className="mb-8">
//           <div className="flex justify-between items-center">
//             <div>
//               <h1 className="text-2xl md:text-3xl font-bold text-[#0C4550]">My Profile</h1>
//               <p className="text-gray-600 mt-2">View your personal information and account security</p>
//             </div>
//             <div className="hidden md:block">
//               <StatusBadge type={userData?.role} />
//             </div>
//           </div>
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">

//           {/* LEFT COLUMN: Profile Card and Account Status */}
//           <div className="lg:col-span-4 space-y-6">
//             {/* Profile Card */}
//             <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100 flex flex-col items-center text-center">
//               <div className="relative group">
//                 <div className="w-32 h-32 rounded-full border-4 border-gray-50 shadow-lg overflow-hidden bg-gray-100 flex items-center justify-center">
//                   {isUploading ? (
//                     <div className="text-gray-400 text-xs font-semibold animate-pulse">Uploading...</div>
//                   ) : profileImage ? (
//                     <img
//                       src={profileImage}
//                       alt="Profile"
//                       className="w-full h-full object-cover"
//                       onError={() => setProfileImage(null)}
//                     />
//                   ) : (
//                     <FiUser className="w-16 h-16 text-gray-300" />
//                   )}
//                 </div>
//                 {!isUploading && (
//                   <label className="absolute inset-0 bg-black/40 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer text-white font-medium text-sm">
//                     <FiCamera className="mr-2" />
//                     Change Photo
//                     <input
//                       type="file"
//                       className="hidden"
//                       accept="image/jpeg, image/png, image/jpg"
//                       onChange={(e) => handleImageUpload(e.target.files[0])}
//                     />
//                   </label>
//                 )}
//               </div>

//               <h2 className="mt-4 text-xl font-bold text-gray-800">
//                 {userData.firstName} {userData.lastName}
//               </h2>
//               <p className="text-sm text-gray-500">{userData.email}</p>
//               {userData.companyName && (
//                 <p className="text-xs font-semibold text-[#0C4550] mt-1">{userData.companyName}</p>
//               )}

//               <div className="mt-6 w-full grid grid-cols-2 gap-3">
//                 <button
//                   onClick={() => setShowWebcam(true)}
//                   disabled={isUploading}
//                   className="flex items-center justify-center gap-2 px-4 py-2.5 bg-gray-50 text-gray-600 rounded-xl text-sm font-semibold hover:bg-gray-100 transition-colors border border-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   <FiCamera /> Webcam
//                 </button>
//                 <label className="flex items-center justify-center gap-2 px-4 py-2.5 bg-[#0C4550]/5 text-[#0C4550] rounded-xl text-sm font-semibold hover:bg-[#0C4550]/10 transition-colors border border-[#0C4550]/20 cursor-pointer">
//                   <FiUpload /> Upload
//                   <input
//                     type="file"
//                     className="hidden"
//                     accept="image/jpeg, image/png, image/jpg"
//                     disabled={isUploading}
//                     onChange={(e) => handleImageUpload(e.target.files[0])}
//                   />
//                 </label>
//               </div>

//               {profileImage && (
//                 <button
//                   onClick={handleDeleteImage}
//                   className="mt-4 w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-red-50 text-red-600 rounded-xl text-sm font-semibold hover:bg-red-100 transition-colors border border-red-100"
//                 >
//                   <FiTrash2 /> Remove Photo
//                 </button>
//               )}
//             </div>

//             {/* Account Status Card */}
//             <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
//               <div className="flex items-center gap-3 mb-6">
//                 <div className="w-12 h-12 bg-[#0C4550]/10 rounded-xl flex items-center justify-center">
//                   <FiInfo className="h-6 w-6 text-[#0C4550]" />
//                 </div>
//                 <div>
//                   <p className="text-xl font-bold text-gray-800">Account Status</p>
//                   <p className="text-gray-500 text-sm">Your current account information</p>
//                 </div>
//               </div>

//               <div className="space-y-4">
//                 <div className="bg-[#0C4550]/5 rounded-xl p-4 border border-[#0C4550]/10">
//                   <h4 className="font-semibold text-[#0C4550] mb-3 flex items-center gap-2">
//                     <FiCheck className="h-4 w-4" />
//                     Status & Role
//                   </h4>
//                   <ul className="space-y-3 text-sm text-[#0C4550]/80">
//                     <li className="flex justify-between items-center">
//                       <span className="text-gray-600">Active Status</span>
//                       <span className={`font-bold ${userData.active ? 'text-green-600' : 'text-red-600'}`}>
//                         {userData.active ? 'Active' : 'Inactive'}
//                       </span>
//                     </li>
//                     <li className="flex justify-between items-center">
//                       <span className="text-gray-600">Role</span>
//                       <StatusBadge type={userData?.role} />
//                     </li>
//                   </ul>
//                 </div>

//                 <div className="bg-[#C5F637]/10 rounded-xl p-4 border border-[#C5F637]/20">
//                   <h4 className="font-semibold text-[#0C4550] mb-3 flex items-center gap-2">
//                     <FiClock className="h-4 w-4" />
//                     Validity & Rates
//                   </h4>
//                   <ul className="space-y-3 text-sm text-[#0C4550]/70">
//                     <DateDisplay label="Valid From" date={userData.validFrom} />
//                     <DateDisplay label="Valid To" date={userData.validTo} />
//                     <li className="flex justify-between items-center border-t border-dashed border-[#0C4550]/20 pt-2 mt-2">
//                       <span className="text-gray-600 font-semibold">SMS Rate</span>
//                       <span className="font-bold text-[#0C4550] text-lg">
//                         {userData.smsRate ? userData.smsRate : '0.00'}
//                       </span>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT COLUMN: Details Form */}
//           <div className="lg:col-span-8">
//             <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
//               <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-[#0C4550]/5 to-transparent">
//                 <div className="flex items-center gap-3">
//                   <div className="w-10 h-10 rounded-xl bg-[#0C4550]/10 flex items-center justify-center">
//                     <FiBriefcase className="h-5 w-5 text-[#0C4550]" />
//                   </div>
//                   <div>
//                     <p className="text-xl font-bold text-gray-800">Profile Details</p>
//                     <p className="text-gray-500 text-sm">Your personal and company details</p>
//                   </div>
//                 </div>
//               </div>

//               <div className="p-6 md:p-8 space-y-8">

//                 {/* Section 1: Personal Info */}
//                 <div>
//                   <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
//                     <FiUser className="text-[#0C4550]" /> Personal Information
//                   </h3>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                     <FormInput label="First Name" value={userData.firstName || ""} disabled icon={FiUser} />
//                     <FormInput label="Last Name" value={userData.lastName || ""} disabled icon={FiUser} />
//                     <FormInput label="Email Address" value={userData.email || ""} disabled icon={FiMail} />
//                     <FormInput label="Phone Number" value={userData.phone || ""} disabled icon={FiPhone} />
//                     <div className="md:col-span-2">
//                       <FormInput label="Address" value={userData.address || ""} disabled icon={FiMapPin} />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="border-t border-gray-100"></div>

//                 {/* Section 2: Company Info */}
//                 <div>
//                   <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
//                     <FiBriefcase className="text-[#0C4550]" /> Company Details
//                   </h3>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                     <FormInput label="Company Name" value={userData.companyName || ""} disabled icon={FiLayers} />
//                     <FormInput label="Company Type" value={userData.companyType || ""} disabled icon={FiBriefcase} />
//                   </div>
//                 </div>

//                 <div className="border-t border-gray-100"></div>

//                 {/* Section 3: Legal Info */}
//                 <div>
//                   <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
//                     <FiShield className="text-[#0C4550]" /> Legal Information
//                   </h3>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                     <FormInput label="GST Number" value={userData.gstNumber || ""} disabled icon={FiShield} />
//                     <FormInput label="PAN Number" value={userData.panNumber || ""} disabled icon={FiCreditCard} />
//                   </div>
//                 </div>

//                 <div className="border-t border-gray-100"></div>

//                 {/* Section 4: API Access */}
//                 <div>
//                   <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
//                     <FiKey className="text-[#0C4550]" /> Developer API Access
//                   </h3>
//                   <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
//                     <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
//                       <div>
//                         <h4 className="font-semibold text-gray-800">Your Secret API Key</h4>
//                         <p className="text-sm text-gray-500 mt-1">Keep this key secret. It grants programmatic access to your account.</p>
//                       </div>

//                       {!apiKey ? (
//                         <button
//                           onClick={() => setShowApiKeyModal(true)}
//                           className="px-5 py-2.5 bg-[#0C4550] text-white rounded-xl text-sm font-semibold hover:bg-[#0C4550]/90 transition-colors shadow-sm flex items-center gap-2 whitespace-nowrap"
//                         >
//                           <FiLock /> Reveal API Key
//                         </button>
//                       ) : (
//                         <div className="flex items-center gap-2 w-full md:w-auto">
//                           <div className="bg-white border border-gray-300 rounded-xl px-4 py-2.5 flex-grow md:flex-grow-0 min-w-[250px] flex items-center justify-between font-mono text-sm">
//                             <span className="text-gray-800 tracking-wider truncate mr-4">
//                               {isApiKeyRevealed ? apiKey : "••••••••••••••••••••••••••••"}
//                             </span>
//                             <button
//                               onClick={() => setIsApiKeyRevealed(!isApiKeyRevealed)}
//                               className="text-gray-500 hover:text-[#0C4550] transition-colors"
//                               title={isApiKeyRevealed ? "Hide Key" : "Show Key"}
//                             >
//                               {isApiKeyRevealed ? <FiEyeOff size={18} /> : <FiEye size={18} />}
//                             </button>
//                           </div>
//                           <button
//                             onClick={copyToClipboard}
//                             className="p-2.5 bg-gray-200 text-gray-700 rounded-xl hover:bg-gray-300 transition-colors flex-shrink-0"
//                             title="Copy to Clipboard"
//                           >
//                             <FiCopy size={18} />
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* API Key Password Modal */}
//       {showApiKeyModal && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
//           <div className="bg-[#F0EFEB] rounded-2xl shadow-2xl overflow-hidden max-w-md w-full">
//             <div className="p-5 border-b border-gray-100 flex justify-between items-center bg-[#0C4550]">
//               <h3 className="font-semibold text-white flex items-center gap-2">
//                 <FiLock className="text-white" /> Verify Identity
//               </h3>
//               <button
//                 onClick={() => {
//                   setShowApiKeyModal(false);
//                   setPasswordVerify("");
//                 }}
//                 className="text-white transition-colors"
//               >
//                 ✕
//               </button>
//             </div>

//             <form onSubmit={handleVerifyAndFetchApiKey} className="p-6">
//               <p className="text-sm text-gray-700 mb-4">
//                 For your security, please enter your account password to view your secret API key.
//               </p>

//               <div className="mb-6">
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Password</label>
//                 <input
//                   type="password"
//                   value={passwordVerify}
//                   onChange={(e) => setPasswordVerify(e.target.value)}
//                   className="w-full px-4 py-3 rounded-xl bg-white border-2 border-slate-200 focus:border-[#0C4550] outline-none transition-all" placeholder="Enter your password"
//                   required
//                 />
//               </div>

//               <div className="flex justify-end gap-3">
//                 <button
//                   type="button"
//                   onClick={() => setShowApiKeyModal(false)}
//                   className="px-5 py-2.5 text-sm font-semibold text-gray-600 hover:bg-gray-100 rounded-xl transition-colors"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   disabled={isVerifyingPassword}
//                   className="px-5 py-2.5 text-sm font-semibold text-white bg-[#0C4550] rounded-xl transition-colors disabled:opacity-70 flex items-center gap-2"
//                 >
//                   {isVerifyingPassword ? "Verifying..." : "View Key"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Webcam Modal */}
//       {showWebcam && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
//           <div className="bg-white rounded-2xl shadow-2xl overflow-hidden max-w-lg w-full">
//             <div className="p-4 border-b border-gray-100 flex justify-between items-center">
//               <h3 className="font-bold text-gray-800">Take Photo</h3>
//               <button
//                 onClick={() => setShowWebcam(false)}
//                 className="text-gray-400 hover:text-gray-600 transition-colors"
//               >
//                 ✕
//               </button>
//             </div>
//             <div className="p-4 bg-black">
//               <ReactWebcam
//                 audio={false}
//                 ref={webcamRef}
//                 screenshotFormat="image/jpeg"
//                 className="rounded-lg w-full"
//                 style={{ transform: "scaleX(-1)" }}
//               />
//             </div>
//             <div className="p-4 flex justify-center gap-4 bg-gray-50">
//               <button
//                 onClick={() => setShowWebcam(false)}
//                 className="px-6 py-2.5 text-sm font-semibold text-gray-600 hover:bg-gray-200 rounded-xl transition-colors"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={captureWebcam}
//                 className="px-6 py-2.5 text-sm font-semibold text-white bg-[#0C4550] rounded-xl hover:bg-[#0C4550]/90 transition-colors"
//               >
//                 Capture Photo
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ProfilePage;








// import React, { useEffect, useState, useContext, useCallback, useRef } from "react";
// import axios from "axios";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import { toast } from "react-toastify";
// import {
//   FiUser,
//   FiMail,
//   FiPhone,
//   FiBriefcase,
//   FiShield,
//   FiCamera,
//   FiUpload,
//   FiTrash2,
//   FiInfo,
//   FiClock,
//   FiCheck,
//   FiMapPin,
//   FiCreditCard,
//   FiLayers,
//   FiKey,
//   FiEye,
//   FiEyeOff,
//   FiCopy,
//   FiLock,
//   FiBookOpen,
//   FiAlertCircle
// } from "react-icons/fi";
// import ReactWebcam from "react-webcam";
// import { getAccessToken } from "../../token";

// // --- Helper Components ---

// const FormInput = ({ label, icon: Icon, ...props }) => (
//   <div className="group">
//     <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center ml-1">
//       {Icon && <Icon className="mr-2 h-4 w-4 text-[#0C4550]" />}
//       {label}
//     </label>
//     <div className="relative">
//       <input
//         {...props}
//         className={`w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#0C4550] focus:ring-2 focus:ring-[#0C4550]/10 transition-all duration-300 hover:border-[#0C4550]/30 shadow-sm ${
//           props.disabled ? "bg-gray-50 text-gray-500 cursor-not-allowed" : ""
//         }`}
//       />
//     </div>
//   </div>
// );

// const StatusBadge = ({ type }) => {
//   const colors = {
//     SUPER_SUPER_ADMIN: "bg-purple-100 text-purple-700 border-purple-200",
//     SUPER_ADMIN: "bg-indigo-100 text-indigo-700 border-indigo-200",
//     COMPANY: "bg-[#0C4550]/10 text-[#0C4550] border-[#0C4550]/20",
//     RESELLER: "bg-[#A7A08F]/10 text-[#0C4550] border-[#A7A08F]/20",
//     default: "bg-gray-100 text-gray-700 border-gray-200",
//   };
//   return (
//     <span className={`px-3 py-1.5 rounded-full text-xs font-bold border ${colors[type] || colors.default}`}>
//       {type?.replace(/_/g, " ") || "USER"}
//     </span>
//   );
// };

// const DateDisplay = ({ label, date }) => {
//   if (!date) return null;
//   const formattedDate = new Date(date).toLocaleDateString("en-US", {
//     year: "numeric",
//     month: "short",
//     day: "numeric",
//   });

//   return (
//     <li className="flex justify-between items-center">
//       <span className="text-gray-600">{label}</span>
//       <span className="font-bold text-gray-600 text-xs md:text-sm">{formattedDate}</span>
//     </li>
//   );
// };

// // --- Main Component ---

// const ProfilePage = () => {
//   const token = getAccessToken();
//   const { user } = useContext(AuthContext);
//   const [userData, setUserData] = useState({});

//   // Image States
//   const [profileImage, setProfileImage] = useState(null);
//   const [showWebcam, setShowWebcam] = useState(false);
//   const [isUploading, setIsUploading] = useState(false);
//   const webcamRef = useRef(null);

//   // API Key States
//   const [apiKey, setApiKey] = useState(null);
//   const [showApiKeyModal, setShowApiKeyModal] = useState(false);
//   const [passwordVerify, setPasswordVerify] = useState("");
//   const [isVerifyingPassword, setIsVerifyingPassword] = useState(false);
//   const [isApiKeyRevealed, setIsApiKeyRevealed] = useState(false);

//   // --- Fetch Profile Image with Authorization ---
//   const loadProfileImage = useCallback(
//     async (filename) => {
//       if (!filename || !token) {
//         setProfileImage(null);
//         return;
//       }

//       try {
//         const fullUrl = `${API_URL}/api/v1/users/photo/${filename}`;
//         const response = await fetch(fullUrl, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: "image/*",
//           },
//         });

//         if (!response.ok) throw new Error(`Failed to load image: ${response.status}`);

//         const blob = await response.blob();
//         const imageUrl = URL.createObjectURL(blob);
//         setProfileImage(imageUrl);
//       } catch (error) {
//         console.error("Error loading profile image:", error);
//         setProfileImage(null);
//       }
//     },
//     [token]
//   );

//   // --- Clean up blob URLs ---
//   useEffect(() => {
//     return () => {
//       if (profileImage && profileImage.startsWith("blob:")) {
//         URL.revokeObjectURL(profileImage);
//       }
//     };
//   }, [profileImage]);

//   // --- Fetch Profile Logic ---
//   const fetchUserProfile = useCallback(async () => {
//     if (!token) return;
//     try {
//       const response = await fetch(`${API_URL}/api/v1/users/me`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (!response.ok) throw new Error("Failed to fetch");
//       const resData = await response.json();
//       if (resData.success && resData.data) {
//         const data = resData.data;
//         setUserData(data);
//         const photoFilename = data.profilePictureUrl;
//         if (photoFilename) loadProfileImage(photoFilename);
//         else setProfileImage(null);
//       }
//     } catch (err) {
//       console.error("Profile fetch error:", err);
//       toast.error("Could not load profile data");
//     }
//   }, [token, loadProfileImage]);

//   useEffect(() => {
//     fetchUserProfile();
//   }, [fetchUserProfile]);

//   // --- Upload Handlers ---
//   const handleImageUpload = async (file) => {
//     if (!file) return;
//     if (!file.type.startsWith("image/")) {
//       toast.error("Please select an image file");
//       return;
//     }
//     if (file.size > 2 * 1024 * 1024) {
//       toast.error("Image size must not exceed 2MB");
//       return;
//     }

//     setIsUploading(true);
//     const localPreview = URL.createObjectURL(file);
//     setProfileImage(localPreview);

//     const formDataUpload = new FormData();
//     formDataUpload.append("file", file);

//     try {
//       const response = await axios.post(`${API_URL}/api/v1/users/photo`, formDataUpload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       if (response.data.success) {
//         toast.success("Profile picture updated successfully!");
//         fetchUserProfile();
//       }
//     } catch (error) {
//       console.error("Upload error:", error);
//       toast.error(error.response?.data?.message || "Failed to upload image");
//       fetchUserProfile();
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   const captureWebcam = useCallback(async () => {
//     const imageSrc = webcamRef.current.getScreenshot();
//     setShowWebcam(false);
//     const blob = await (await fetch(imageSrc)).blob();
//     const file = new File([blob], "webcam-capture.jpg", { type: "image/jpeg" });
//     await handleImageUpload(file);
//   }, [webcamRef, handleImageUpload]);

//   const handleDeleteImage = async () => {
//     if (!window.confirm("Are you sure you want to remove your profile picture?")) return;
//     try {
//       const response = await axios.delete(`${API_URL}/api/v1/users/photo`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (response.data.success) {
//         if (profileImage && profileImage.startsWith("blob:")) URL.revokeObjectURL(profileImage);
//         setProfileImage(null);
//         toast.success("Profile picture removed successfully!");
//         fetchUserProfile();
//       }
//     } catch (error) {
//       console.error("Delete error:", error);
//       toast.error("Failed to remove profile picture");
//     }
//   };

//   // --- API Key Handlers ---
//   const handleVerifyAndFetchApiKey = async (e) => {
//     e.preventDefault();
//     if (!passwordVerify) {
//       toast.error("Please enter your password");
//       return;
//     }

//     setIsVerifyingPassword(true);
//     try {
//       await axios.post(
//         `${API_URL}/api/v1/auth/verify-password`,
//         {
//           password: passwordVerify,
//         },
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       const response = await axios.get(`${API_URL}/api/v1/apikeys/me`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       setApiKey(response.data.apiKey);
//       setShowApiKeyModal(false);
//       setPasswordVerify("");
//       setIsApiKeyRevealed(true);
//       toast.success("API Key revealed successfully");
//     } catch (error) {
//       console.error("Verification error:", error);
//       toast.error(error.response?.data?.message || "Incorrect password or failed to fetch API key");
//     } finally {
//       setIsVerifyingPassword(false);
//     }
//   };

//   const copyToClipboard = () => {
//     if (apiKey) {
//       navigator.clipboard.writeText(apiKey);
//       toast.success("API Key copied to clipboard!");
//     }
//   };

//   return (
//     <div className="min-h-screen bg-[#F0EFEB] font-sans p-4 md:p-6">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="mb-8">
//           <div className="flex justify-between items-center">
//             <div>
//               <h1 className="text-2xl md:text-3xl font-bold text-[#0C4550]">My Profile</h1>
//               <p className="text-gray-600 mt-2">View your personal information and account security</p>
//             </div>
//             <div className="hidden md:block">
//               <StatusBadge type={userData?.role} />
//             </div>
//           </div>
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
//           {/* LEFT COLUMN: Profile Card, Account Status, and Instructions */}
//           <div className="lg:col-span-4 space-y-6">
//             {/* Profile Card */}
//             <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100 flex flex-col items-center text-center">
//               <div className="relative group">
//                 <div className="w-32 h-32 rounded-full border-4 border-gray-50 shadow-lg overflow-hidden bg-gray-100 flex items-center justify-center">
//                   {isUploading ? (
//                     <div className="text-gray-400 text-xs font-semibold animate-pulse">Uploading...</div>
//                   ) : profileImage ? (
//                     <img
//                       src={profileImage}
//                       alt="Profile"
//                       className="w-full h-full object-cover"
//                       onError={() => setProfileImage(null)}
//                     />
//                   ) : (
//                     <FiUser className="w-16 h-16 text-gray-300" />
//                   )}
//                 </div>
//                 {!isUploading && (
//                   <label className="absolute inset-0 bg-black/40 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer text-white font-medium text-sm">
//                     <FiCamera className="mr-2" />
//                     Change Photo
//                     <input
//                       type="file"
//                       className="hidden"
//                       accept="image/jpeg, image/png, image/jpg"
//                       onChange={(e) => handleImageUpload(e.target.files[0])}
//                     />
//                   </label>
//                 )}
//               </div>

//               <h2 className="mt-4 text-xl font-bold text-gray-800">
//                 {userData.firstName} {userData.lastName}
//               </h2>
//               <p className="text-sm text-gray-500">{userData.email}</p>
//               {userData.companyName && (
//                 <p className="text-xs font-semibold text-[#0C4550] mt-1">{userData.companyName}</p>
//               )}

//               <div className="mt-6 w-full grid grid-cols-2 gap-3">
//                 <button
//                   onClick={() => setShowWebcam(true)}
//                   disabled={isUploading}
//                   className="flex items-center justify-center gap-2 px-4 py-2.5 bg-gray-50 text-gray-600 rounded-xl text-sm font-semibold hover:bg-gray-100 transition-colors border border-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   <FiCamera /> Webcam
//                 </button>
//                 <label className="flex items-center justify-center gap-2 px-4 py-2.5 bg-[#0C4550]/5 text-[#0C4550] rounded-xl text-sm font-semibold hover:bg-[#0C4550]/10 transition-colors border border-[#0C4550]/20 cursor-pointer">
//                   <FiUpload /> Upload
//                   <input
//                     type="file"
//                     className="hidden"
//                     accept="image/jpeg, image/png, image/jpg"
//                     disabled={isUploading}
//                     onChange={(e) => handleImageUpload(e.target.files[0])}
//                   />
//                 </label>
//               </div>

//               {profileImage && (
//                 <button
//                   onClick={handleDeleteImage}
//                   className="mt-4 w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-red-50 text-red-600 rounded-xl text-sm font-semibold hover:bg-red-100 transition-colors border border-red-100"
//                 >
//                   <FiTrash2 /> Remove Photo
//                 </button>
//               )}
//             </div>

//             {/* Account Status Card */}
//             <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
//               <div className="flex items-center gap-3 mb-6">
//                 <div className="w-12 h-12 bg-[#0C4550]/10 rounded-xl flex items-center justify-center">
//                   <FiInfo className="h-6 w-6 text-[#0C4550]" />
//                 </div>
//                 <div>
//                   <p className="text-xl font-bold text-gray-800">Account Status</p>
//                   <p className="text-gray-500 text-sm">Your current account information</p>
//                 </div>
//               </div>

//               <div className="space-y-4">
//                 <div className="bg-[#0C4550]/5 rounded-xl p-4 border border-[#0C4550]/10">
//                   <h4 className="font-semibold text-[#0C4550] mb-3 flex items-center gap-2">
//                     <FiCheck className="h-4 w-4" />
//                     Status & Role
//                   </h4>
//                   <ul className="space-y-3 text-sm text-[#0C4550]/80">
//                     <li className="flex justify-between items-center">
//                       <span className="text-gray-600">Active Status</span>
//                       <span className={`font-bold ${userData.active ? "text-green-600" : "text-red-600"}`}>
//                         {userData.active ? "Active" : "Inactive"}
//                       </span>
//                     </li>
//                     <li className="flex justify-between items-center">
//                       <span className="text-gray-600">Role</span>
//                       <StatusBadge type={userData?.role} />
//                     </li>
//                   </ul>
//                 </div>

//                 <div className="bg-[#C5F637]/10 rounded-xl p-4 border border-[#C5F637]/20">
//                   <h4 className="font-semibold text-[#0C4550] mb-3 flex items-center gap-2">
//                     <FiClock className="h-4 w-4" />
//                     Validity & Rates
//                   </h4>
//                   <ul className="space-y-3 text-sm text-[#0C4550]/70">
//                     <DateDisplay label="Valid From" date={userData.validFrom} />
//                     <DateDisplay label="Valid To" date={userData.validTo} />
//                     <li className="flex justify-between items-center border-t border-dashed border-[#0C4550]/20 pt-2 mt-2">
//                       <span className="text-gray-600 font-semibold">SMS Rate</span>
//                       <span className="font-bold text-[#0C4550] text-lg">
//                         {userData.smsRate ? userData.smsRate : "0.00"}
//                       </span>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>

//             {/* Quick Guide Section */}
//             <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
//               <div className="flex items-center gap-3 mb-4">
//                 <div className="w-10 h-10 bg-[#F46653]/10 rounded-xl flex items-center justify-center">
//                   <FiBookOpen className="h-5 w-5 text-[#F46653]" />
//                 </div>
//                 <p className="text-lg font-bold text-gray-800">Quick Guide</p>
//               </div>
//               <ul className="space-y-4">
//                 <li className="flex gap-3">
//                   <FiCheck className="text-green-500 mt-1 flex-shrink-0" />
//                   <p className="text-sm text-gray-600">
//                     Keep your profile updated to ensure seamless communication and accurate billing reports.
//                   </p>
//                 </li>
//                 <li className="flex gap-3">
//                   <FiAlertCircle className="text-[#0C4550] mt-1 flex-shrink-0" />
//                   <p className="text-sm text-gray-600">
//                     Your <span className="font-bold">Secret API Key</span> is sensitive information. Never share it via
//                     email or public repositories.
//                   </p>
//                 </li>
//                 <li className="flex gap-3">
//                   <FiShield className="text-[#0C4550] mt-1 flex-shrink-0" />
//                   <p className="text-sm text-gray-600">
//                     For security reasons, changing your primary account details requires contacting{" "}
//                     <span className="font-bold">info@deetyasoft.com</span>.
//                   </p>
//                 </li>
//               </ul>
//             </div>
//           </div>

//           {/* RIGHT COLUMN: Details Form */}
//           <div className="lg:col-span-8">
//             <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
//               <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-[#0C4550]/5 to-transparent">
//                 <div className="flex items-center gap-3">
//                   <div className="w-10 h-10 rounded-xl bg-[#0C4550]/10 flex items-center justify-center">
//                     <FiBriefcase className="h-5 w-5 text-[#0C4550]" />
//                   </div>
//                   <div>
//                     <p className="text-xl font-bold text-gray-800">Profile Details</p>
//                     <p className="text-gray-500 text-sm">Your personal and company details</p>
//                   </div>
//                 </div>
//               </div>

//               <div className="p-6 md:p-8 space-y-8">
//                 {/* Section 1: Personal Info */}
//                 <div>
//                   <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
//                     <FiUser className="text-[#0C4550]" /> Personal Information
//                   </h3>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                     <FormInput label="First Name" value={userData.firstName || ""} disabled icon={FiUser} />
//                     <FormInput label="Last Name" value={userData.lastName || ""} disabled icon={FiUser} />
//                     <FormInput label="Email Address" value={userData.email || ""} disabled icon={FiMail} />
//                     <FormInput label="Phone Number" value={userData.phone || ""} disabled icon={FiPhone} />
//                     <div className="md:col-span-2">
//                       <FormInput label="Address" value={userData.address || ""} disabled icon={FiMapPin} />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="border-t border-gray-100"></div>

//                 {/* Section 2: Company Info */}
//                 <div>
//                   <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
//                     <FiBriefcase className="text-[#0C4550]" /> Company Details
//                   </h3>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                     <FormInput label="Company Name" value={userData.companyName || ""} disabled icon={FiLayers} />
//                     <FormInput label="Company Type" value={userData.companyType || ""} disabled icon={FiBriefcase} />
//                   </div>
//                 </div>

//                 <div className="border-t border-gray-100"></div>

//                 {/* Section 3: Legal Info */}
//                 <div>
//                   <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
//                     <FiShield className="text-[#0C4550]" /> Legal Information
//                   </h3>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                     <FormInput label="GST Number" value={userData.gstNumber || ""} disabled icon={FiShield} />
//                     <FormInput label="PAN Number" value={userData.panNumber || ""} disabled icon={FiCreditCard} />
//                   </div>
//                 </div>

//                 <div className="border-t border-gray-100"></div>

//                 {/* Section 4: API Access */}
//                 <div>
//                   <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
//                     <FiKey className="text-[#0C4550]" /> Developer API Access
//                   </h3>
//                   <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
//                     <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
//                       <div>
//                         <h4 className="font-semibold text-gray-800">Your Secret API Key</h4>
//                         <p className="text-sm text-gray-500 mt-1">
//                           Keep this key secret. It grants programmatic access to your account.
//                         </p>
//                       </div>

//                       {!apiKey ? (
//                         <button
//                           onClick={() => setShowApiKeyModal(true)}
//                           className="px-5 py-2.5 bg-[#0C4550] text-white rounded-xl text-sm font-semibold hover:bg-[#0C4550]/90 transition-colors shadow-sm flex items-center gap-2 whitespace-nowrap"
//                         >
//                           <FiLock /> Reveal API Key
//                         </button>
//                       ) : (
//                         <div className="flex items-center gap-2 w-full md:w-auto">
//                           <div className="bg-white border border-gray-300 rounded-xl px-4 py-2.5 flex-grow md:flex-grow-0 min-w-[250px] flex items-center justify-between font-mono text-sm">
//                             <span className="text-gray-800 tracking-wider truncate mr-4">
//                               {isApiKeyRevealed ? apiKey : "••••••••••••••••••••••••••••"}
//                             </span>
//                             <button
//                               onClick={() => setIsApiKeyRevealed(!isApiKeyRevealed)}
//                               className="text-gray-500 hover:text-[#0C4550] transition-colors"
//                               title={isApiKeyRevealed ? "Hide Key" : "Show Key"}
//                             >
//                               {isApiKeyRevealed ? <FiEyeOff size={18} /> : <FiEye size={18} />}
//                             </button>
//                           </div>
//                           <button
//                             onClick={copyToClipboard}
//                             className="p-2.5 bg-gray-200 text-gray-700 rounded-xl hover:bg-gray-300 transition-colors flex-shrink-0"
//                             title="Copy to Clipboard"
//                           >
//                             <FiCopy size={18} />
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* API Key Password Modal */}
//       {showApiKeyModal && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
//           <div className="bg-[#F0EFEB] rounded-2xl shadow-2xl overflow-hidden max-w-md w-full">
//             <div className="p-5 border-b border-gray-100 flex justify-between items-center bg-[#0C4550]">
//               <h3 className="font-semibold text-white flex items-center gap-2">
//                 <FiLock className="text-white" /> Verify Identity
//               </h3>
//               <button
//                 onClick={() => {
//                   setShowApiKeyModal(false);
//                   setPasswordVerify("");
//                 }}
//                 className="text-white transition-colors"
//               >
//                 ✕
//               </button>
//             </div>

//             <form onSubmit={handleVerifyAndFetchApiKey} className="p-6">
//               <p className="text-sm text-gray-700 mb-4">
//                 For your security, please enter your account password to view your secret API key.
//               </p>

//               <div className="mb-6">
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Password</label>
//                 <input
//                   type="password"
//                   value={passwordVerify}
//                   onChange={(e) => setPasswordVerify(e.target.value)}
//                   className="w-full px-4 py-3 rounded-xl bg-white border-2 border-slate-200 focus:border-[#0C4550] outline-none transition-all"
//                   placeholder="Enter your password"
//                   required
//                 />
//               </div>

//               <div className="flex justify-end gap-3">
//                 <button
//                   type="button"
//                   onClick={() => setShowApiKeyModal(false)}
//                   className="px-5 py-2.5 text-sm font-semibold text-gray-600 hover:bg-gray-100 rounded-xl transition-colors"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   disabled={isVerifyingPassword}
//                   className="px-5 py-2.5 text-sm font-semibold text-white bg-[#0C4550] rounded-xl transition-colors disabled:opacity-70 flex items-center gap-2"
//                 >
//                   {isVerifyingPassword ? "Verifying..." : "View Key"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Webcam Modal */}
//       {showWebcam && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
//           <div className="bg-white rounded-2xl shadow-2xl overflow-hidden max-w-lg w-full">
//             <div className="p-4 border-b border-gray-100 flex justify-between items-center">
//               <h3 className="font-bold text-gray-800">Take Photo</h3>
//               <button
//                 onClick={() => setShowWebcam(false)}
//                 className="text-gray-400 hover:text-gray-600 transition-colors"
//               >
//                 ✕
//               </button>
//             </div>
//             <div className="p-4 bg-black">
//               <ReactWebcam
//                 audio={false}
//                 ref={webcamRef}
//                 screenshotFormat="image/jpeg"
//                 className="rounded-lg w-full"
//                 style={{ transform: "scaleX(-1)" }}
//               />
//             </div>
//             <div className="p-4 flex justify-center gap-4 bg-gray-50">
//               <button
//                 onClick={() => setShowWebcam(false)}
//                 className="px-6 py-2.5 text-sm font-semibold text-gray-600 hover:bg-gray-200 rounded-xl transition-colors"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={captureWebcam}
//                 className="px-6 py-2.5 text-sm font-semibold text-white bg-[#0C4550] rounded-xl hover:bg-[#0C4550]/90 transition-colors"
//               >
//                 Capture Photo
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ProfilePage;




import React, { useEffect, useState, useContext, useCallback, useRef } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";
import { toast } from "react-toastify";
import {
  FiUser,
  FiMail,
  FiPhone,
  FiBriefcase,
  FiShield,
  FiCamera,
  FiUpload,
  FiTrash2,
  FiInfo,
  FiClock,
  FiCheck,
  FiMapPin,
  FiCreditCard,
  FiLayers,
  FiKey,
  FiEye,
  FiEyeOff,
  FiCopy,
  FiLock,
  FiBookOpen,
  FiAlertCircle,
  FiX,
  FiImage
} from "react-icons/fi";
import ReactWebcam from "react-webcam";
import { getAccessToken } from "../../token";

// --- Helper Components ---

const FormInput = ({ label, icon: Icon, ...props }) => (
  <div className="group">
    <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center ml-1">
      {Icon && <Icon className="mr-2 h-4 w-4 text-[#0C4550]" />}
      {label}
    </label>
    <div className="relative">
      <input
        {...props}
        className={`w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#0C4550] focus:ring-2 focus:ring-[#0C4550]/10 transition-all duration-300 hover:border-[#0C4550]/30 shadow-sm ${
          props.disabled ? "bg-gray-50 text-gray-500 cursor-not-allowed" : ""
        }`}
      />
    </div>
  </div>
);

const StatusBadge = ({ type }) => {
  const colors = {
    SUPER_SUPER_ADMIN: "bg-purple-100 text-purple-700 border-purple-200",
    SUPER_ADMIN: "bg-indigo-100 text-indigo-700 border-indigo-200",
    COMPANY: "bg-[#0C4550]/10 text-[#0C4550] border-[#0C4550]/20",
    RESELLER: "bg-[#A7A08F]/10 text-[#0C4550] border-[#A7A08F]/20",
    default: "bg-gray-100 text-gray-700 border-gray-200",
  };
  return (
    <span className={`px-3 py-1.5 rounded-full text-xs font-bold border ${colors[type] || colors.default}`}>
      {type?.replace(/_/g, " ") || "USER"}
    </span>
  );
};

const DateDisplay = ({ label, date }) => {
  if (!date) return null;
  const formattedDate = new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  return (
    <li className="flex justify-between items-center">
      <span className="text-gray-600">{label}</span>
      <span className="font-bold text-gray-600 text-xs md:text-sm">{formattedDate}</span>
    </li>
  );
};

// --- Main Component ---

const ProfilePage = () => {
  const token = getAccessToken();
  const { user } = useContext(AuthContext);
  const [userData, setUserData] = useState({});

  // Image States
  const [profileImage, setProfileImage] = useState(null);
  const [showWebcam, setShowWebcam] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const webcamRef = useRef(null);
  const fileInputRef = useRef(null);

  // API Key States
  const [apiKey, setApiKey] = useState(null);
  const [showApiKeyModal, setShowApiKeyModal] = useState(false);
  const [passwordVerify, setPasswordVerify] = useState("");
  const [isVerifyingPassword, setIsVerifyingPassword] = useState(false);
  const [isApiKeyRevealed, setIsApiKeyRevealed] = useState(false);

  // --- Fetch Profile Image with Authorization ---
  const loadProfileImage = useCallback(
    async (filename) => {
      if (!filename || !token) {
        setProfileImage(null);
        return;
      }

      try {
        const fullUrl = `${API_URL}/api/v1/users/photo/${filename}`;
        const response = await fetch(fullUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "image/*",
          },
        });

        if (!response.ok) throw new Error(`Failed to load image: ${response.status}`);

        const blob = await response.blob();
        const imageUrl = URL.createObjectURL(blob);
        setProfileImage(imageUrl);
      } catch (error) {
        console.error("Error loading profile image:", error);
        setProfileImage(null);
      }
    },
    [token]
  );

  // --- Clean up blob URLs ---
  useEffect(() => {
    return () => {
      if (profileImage && profileImage.startsWith("blob:")) {
        URL.revokeObjectURL(profileImage);
      }
    };
  }, [profileImage]);

  // --- Fetch Profile Logic ---
  const fetchUserProfile = useCallback(async () => {
    if (!token) return;
    try {
      const response = await fetch(`${API_URL}/api/v1/users/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("Failed to fetch");
      const resData = await response.json();
      if (resData.success && resData.data) {
        const data = resData.data;
        setUserData(data);
        const photoFilename = data.profilePictureUrl;
        if (photoFilename) loadProfileImage(photoFilename);
        else setProfileImage(null);
      }
    } catch (err) {
      console.error("Profile fetch error:", err);
      toast.error("Could not load profile data");
    }
  }, [token, loadProfileImage]);

  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);

  // --- Upload Handlers ---
  const handleImageUpload = async (file) => {
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Please select an image file");
      return;
    }
    if (file.size > 2 * 1024 * 1024) {
      toast.error("Image size must not exceed 2MB");
      return;
    }

    setIsUploading(true);
    const localPreview = URL.createObjectURL(file);
    setProfileImage(localPreview);

    const formDataUpload = new FormData();
    formDataUpload.append("file", file);

    try {
      const response = await axios.post(`${API_URL}/api/v1/users/photo`, formDataUpload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.data.success) {
        toast.success("Profile picture updated successfully!");
        setShowViewModal(false);
        fetchUserProfile();
      }
    } catch (error) {
      console.error("Upload error:", error);
      toast.error(error.response?.data?.message || "Failed to upload image");
      fetchUserProfile();
    } finally {
      setIsUploading(false);
    }
  };

  const captureWebcam = useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setShowWebcam(false);
    const blob = await (await fetch(imageSrc)).blob();
    const file = new File([blob], "webcam-capture.jpg", { type: "image/jpeg" });
    await handleImageUpload(file);
  }, [webcamRef, handleImageUpload]);

  const handleDeleteImage = async () => {
    if (!window.confirm("Are you sure you want to remove your profile picture?")) return;
    try {
      const response = await axios.delete(`${API_URL}/api/v1/users/photo`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.success) {
        if (profileImage && profileImage.startsWith("blob:")) URL.revokeObjectURL(profileImage);
        setProfileImage(null);
        toast.success("Profile picture removed successfully!");
        fetchUserProfile();
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Failed to remove profile picture");
    }
  };

  // --- API Key Handlers ---
  const handleVerifyAndFetchApiKey = async (e) => {
    e.preventDefault();
    if (!passwordVerify) {
      toast.error("Please enter your password");
      return;
    }

    setIsVerifyingPassword(true);
    try {
      await axios.post(
        `${API_URL}/api/v1/auth/verify-password`,
        {
          password: passwordVerify,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const response = await axios.get(`${API_URL}/api/v1/apikeys/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setApiKey(response.data.apiKey);
      setShowApiKeyModal(false);
      setPasswordVerify("");
      setIsApiKeyRevealed(true);
      toast.success("API Key revealed successfully");
    } catch (error) {
      console.error("Verification error:", error);
      toast.error(error.response?.data?.message || "Incorrect password or failed to fetch API key");
    } finally {
      setIsVerifyingPassword(false);
    }
  };

  const copyToClipboard = () => {
    if (apiKey) {
      navigator.clipboard.writeText(apiKey);
      toast.success("API Key copied to clipboard!");
    }
  };

  return (
    <div className="min-h-screen bg-[#F0EFEB] font-sans p-4 md:p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-[#0C4550]">My Profile</h1>
              <p className="text-gray-600 mt-2">View your personal information and account security</p>
            </div>
            <div className="hidden md:block">
              <StatusBadge type={userData?.role} />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-4 space-y-6">
            {/* Profile Card */}
            <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100 flex flex-col items-center text-center">
              <div className="relative group">
                <div className="w-32 h-32 rounded-full border-4 border-gray-50 shadow-lg overflow-hidden bg-gray-100 flex items-center justify-center">
                  {isUploading ? (
                    <div className="text-gray-400 text-xs font-semibold animate-pulse">Uploading...</div>
                  ) : profileImage ? (
                    <img
                      src={profileImage}
                      alt="Profile"
                      className="w-full h-full object-cover"
                      onError={() => setProfileImage(null)}
                    />
                  ) : (
                    <FiUser className="w-16 h-16 text-gray-300" />
                  )}
                </div>
                
                {/* Condition Based Hover logic */}
                {!isUploading && (
                  profileImage ? (
                    <button 
                      onClick={() => setShowViewModal(true)}
                      className="absolute inset-0 bg-black/40 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-pointer text-white font-medium text-sm border-none outline-none"
                    >
                      <FiEye className="mr-2" />
                      View
                    </button>
                  ) : (
                    <div className="absolute inset-0 bg-black/60 rounded-full flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 cursor-default text-white p-2">
                      <FiImage className="mb-1 text-lg" />
                      <span className="text-[10px] font-medium uppercase tracking-tighter">No Profile Photo</span>
                    </div>
                  )
                )}

                <input
                  ref={fileInputRef}
                  type="file"
                  className="hidden"
                  accept="image/jpeg, image/png, image/jpg"
                  onChange={(e) => handleImageUpload(e.target.files[0])}
                />
              </div>

              <h2 className="mt-4 text-xl font-bold text-gray-800">
                {userData.firstName} {userData.lastName}
              </h2>
              <p className="text-sm text-gray-500">{userData.email}</p>
              {userData.companyName && (
                <p className="text-xs font-semibold text-[#0C4550] mt-1">{userData.companyName}</p>
              )}

              <div className="mt-6 w-full grid grid-cols-2 gap-3">
                <button
                  onClick={() => setShowWebcam(true)}
                  disabled={isUploading}
                  className="flex items-center justify-center gap-2 px-4 py-2.5 bg-gray-50 text-gray-600 rounded-xl text-sm font-semibold hover:bg-gray-100 transition-colors border border-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <FiCamera /> Webcam
                </button>
                <label className="flex items-center justify-center gap-2 px-4 py-2.5 bg-[#0C4550]/5 text-[#0C4550] rounded-xl text-sm font-semibold hover:bg-[#0C4550]/10 transition-colors border border-[#0C4550]/20 cursor-pointer">
                  <FiUpload /> Upload
                  <input
                    type="file"
                    className="hidden"
                    accept="image/jpeg, image/png, image/jpg"
                    disabled={isUploading}
                    onChange={(e) => handleImageUpload(e.target.files[0])}
                  />
                </label>
              </div>

              {profileImage && (
                <button
                  onClick={handleDeleteImage}
                  className="mt-4 w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-red-50 text-red-600 rounded-xl text-sm font-semibold hover:bg-red-100 transition-colors border border-red-100"
                >
                  <FiTrash2 /> Remove Photo
                </button>
              )}
            </div>

            {/* Account Status Card */}
            <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-[#0C4550]/10 rounded-xl flex items-center justify-center">
                  <FiInfo className="h-6 w-6 text-[#0C4550]" />
                </div>
                <div>
                  <p className="text-xl font-bold text-gray-800">Account Status</p>
                  <p className="text-gray-500 text-sm">Your current account information</p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="bg-[#0C4550]/5 rounded-xl p-4 border border-[#0C4550]/10">
                  <h4 className="font-semibold text-[#0C4550] mb-3 flex items-center gap-2">
                    <FiCheck className="h-4 w-4" />
                    Status & Role
                  </h4>
                  <ul className="space-y-3 text-sm text-[#0C4550]/80">
                    <li className="flex justify-between items-center">
                      <span className="text-gray-600">Active Status</span>
                      <span className={`font-bold ${userData.active ? "text-green-600" : "text-red-600"}`}>
                        {userData.active ? "Active" : "Inactive"}
                      </span>
                    </li>
                    <li className="flex justify-between items-center">
                      <span className="text-gray-600">Role</span>
                      <StatusBadge type={userData?.role} />
                    </li>
                  </ul>
                </div>

                <div className="bg-[#C5F637]/10 rounded-xl p-4 border border-[#C5F637]/20">
                  <h4 className="font-semibold text-[#0C4550] mb-3 flex items-center gap-2">
                    <FiClock className="h-4 w-4" />
                    Validity & Rates
                  </h4>
                  <ul className="space-y-3 text-sm text-[#0C4550]/70">
                    <DateDisplay label="Valid From" date={userData.validFrom} />
                    <DateDisplay label="Valid To" date={userData.validTo} />
                    <li className="flex justify-between items-center border-t border-dashed border-[#0C4550]/20 pt-2 mt-2">
                      <span className="text-gray-600 font-semibold">SMS Rate</span>
                      <span className="font-bold text-[#0C4550] text-lg">
                        {userData.smsRate ? userData.smsRate : "0.00"}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Quick Guide Section */}
            <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#F46653]/10 rounded-xl flex items-center justify-center">
                  <FiBookOpen className="h-5 w-5 text-[#F46653]" />
                </div>
                <p className="text-lg font-bold text-gray-800">Quick Guide</p>
              </div>
              <ul className="space-y-4">
                <li className="flex gap-3">
                  <FiCheck className="text-green-500 mt-1 flex-shrink-0" />
                  <p className="text-sm text-gray-600">
                    Keep your profile updated to ensure seamless communication and accurate billing reports.
                  </p>
                </li>
                <li className="flex gap-3">
                  <FiAlertCircle className="text-[#0C4550] mt-1 flex-shrink-0" />
                  <p className="text-sm text-gray-600">
                    Your <span className="font-bold">Secret API Key</span> is sensitive information. Never share it via
                    email or public repositories.
                  </p>
                </li>
                <li className="flex gap-3">
                  <FiShield className="text-[#0C4550] mt-1 flex-shrink-0" />
                  <p className="text-sm text-gray-600">
                    For security reasons, changing your primary account details requires contacting{" "}
                    <span className="font-bold">info@deetyasoft.com</span>.
                  </p>
                </li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
              <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-[#0C4550]/5 to-transparent">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-[#0C4550]/10 flex items-center justify-center">
                    <FiBriefcase className="h-5 w-5 text-[#0C4550]" />
                  </div>
                  <div>
                    <p className="text-xl font-bold text-gray-800">Profile Details</p>
                    <p className="text-gray-500 text-sm">Your personal and company details</p>
                  </div>
                </div>
              </div>

              <div className="p-6 md:p-8 space-y-8">
                {/* Section 1: Personal Info */}
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <FiUser className="text-[#0C4550]" /> Personal Information
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <FormInput label="First Name" value={userData.firstName || ""} disabled icon={FiUser} />
                    <FormInput label="Last Name" value={userData.lastName || ""} disabled icon={FiUser} />
                    <FormInput label="Email Address" value={userData.email || ""} disabled icon={FiMail} />
                    <FormInput label="Phone Number" value={userData.phone || ""} disabled icon={FiPhone} />
                    <div className="md:col-span-2">
                      <FormInput label="Address" value={userData.address || ""} disabled icon={FiMapPin} />
                    </div>
                  </div>
                </div>

                <div className="border-t border-gray-100"></div>

                {/* Section 2: Company Info */}
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <FiBriefcase className="text-[#0C4550]" /> Company Details
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <FormInput label="Company Name" value={userData.companyName || ""} disabled icon={FiLayers} />
                    <FormInput label="Company Type" value={userData.companyType || ""} disabled icon={FiBriefcase} />
                  </div>
                </div>

                <div className="border-t border-gray-100"></div>

                {/* Section 3: Legal Info */}
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <FiShield className="text-[#0C4550]" /> Legal Information
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <FormInput label="GST Number" value={userData.gstNumber || ""} disabled icon={FiShield} />
                    <FormInput label="PAN Number" value={userData.panNumber || ""} disabled icon={FiCreditCard} />
                  </div>
                </div>

                <div className="border-t border-gray-100"></div>

                {/* Section 4: API Access */}
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <FiKey className="text-[#0C4550]" /> Developer API Access
                  </h3>
                  <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                      <div>
                        <h4 className="font-semibold text-gray-800">Your Secret API Key</h4>
                        <p className="text-sm text-gray-500 mt-1">
                          Keep this key secret. It grants programmatic access to your account.
                        </p>
                      </div>

                      {!apiKey ? (
                        <button
                          onClick={() => setShowApiKeyModal(true)}
                          className="px-5 py-2.5 bg-[#0C4550] text-white rounded-xl text-sm font-semibold hover:bg-[#0C4550]/90 transition-colors shadow-sm flex items-center gap-2 whitespace-nowrap"
                        >
                          <FiLock /> Reveal API Key
                        </button>
                      ) : (
                        <div className="flex items-center gap-2 w-full md:w-auto">
                          <div className="bg-white border border-gray-300 rounded-xl px-4 py-2.5 flex-grow md:flex-grow-0 min-w-[250px] flex items-center justify-between font-mono text-sm">
                            <span className="text-gray-800 tracking-wider truncate mr-4">
                              {isApiKeyRevealed ? apiKey : "••••••••••••••••••••••••••••"}
                            </span>
                            <button
                              onClick={() => setIsApiKeyRevealed(!isApiKeyRevealed)}
                              className="text-gray-500 hover:text-[#0C4550] transition-colors"
                              title={isApiKeyRevealed ? "Hide Key" : "Show Key"}
                            >
                              {isApiKeyRevealed ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                            </button>
                          </div>
                          <button
                            onClick={copyToClipboard}
                            className="p-2.5 bg-gray-200 text-gray-700 rounded-xl hover:bg-gray-300 transition-colors flex-shrink-0"
                            title="Copy to Clipboard"
                          >
                            <FiCopy size={18} />
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Profile Photo View Modal */}
      {showViewModal && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-md p-4">
          <div className="bg-white/20 rounded-2xl shadow-2xl overflow-hidden max-w-lg w-full relative animate-in fade-in zoom-in duration-300">
            <button
              onClick={() => setShowViewModal(false)}
              className="absolute top-3 right-3 z-10 p-2 bg-white/80 hover:bg-white rounded-full transition-colors shadow-sm"
            >
              <FiX className="h-5 w-5 text-gray-800" />
            </button>
            
            <div className="p-4">
              <div className="aspect-square w-full rounded-xl overflow-hidden bg-gray-100 flex items-center justify-center">
                {profileImage ? (
                  <img src={profileImage} alt="Profile Preview" className="w-full h-full object-cover" />
                ) : (
                  <FiUser className="w-24 h-24 text-gray-300" />
                )}
              </div>
              
              <div className="mt-4">
                <button
                  onClick={() => fileInputRef.current?.click()}
                  className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-[#0C4550] text-white rounded-xl text-sm font-semibold transition-all"
                >
                  <FiCamera /> Change Photo
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* API Key Password Modal */}
      {showApiKeyModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
          <div className="bg-[#F0EFEB] rounded-2xl shadow-2xl overflow-hidden max-w-md w-full">
            <div className="p-5 border-b border-gray-100 flex justify-between items-center bg-[#0C4550]">
              <h3 className="font-semibold text-white flex items-center gap-2">
                <FiLock className="text-white" /> Verify Identity
              </h3>
              <button
                onClick={() => {
                  setShowApiKeyModal(false);
                  setPasswordVerify("");
                }}
                className="text-white transition-colors"
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleVerifyAndFetchApiKey} className="p-6">
              <p className="text-sm text-gray-700 mb-4">
                For your security, please enter your account password to view your secret API key.
              </p>

              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Password</label>
                <input
                  type="password"
                  value={passwordVerify}
                  onChange={(e) => setPasswordVerify(e.target.value)}
                  className="w-full px-4 py-3 rounded-xl bg-white border-2 border-slate-200 focus:border-[#0C4550] outline-none transition-all"
                  placeholder="Enter your password"
                  required
                />
              </div>

              <div className="flex justify-end gap-3">
                <button
                  type="button"
                  onClick={() => setShowApiKeyModal(false)}
                  className="px-5 py-2.5 text-sm font-semibold text-gray-600 hover:bg-gray-100 rounded-xl transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isVerifyingPassword}
                  className="px-5 py-2.5 text-sm font-semibold text-white bg-[#0C4550] rounded-xl transition-colors disabled:opacity-70 flex items-center gap-2"
                >
                  {isVerifyingPassword ? "Verifying..." : "View Key"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Webcam Modal */}
      {showWebcam && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden max-w-lg w-full">
            <div className="p-4 border-b border-gray-100 flex justify-between items-center">
              <h3 className="font-bold text-gray-800">Take Photo</h3>
              <button
                onClick={() => setShowWebcam(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                ✕
              </button>
            </div>
            <div className="p-4 bg-black">
              <ReactWebcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                className="rounded-lg w-full"
                style={{ transform: "scaleX(-1)" }}
              />
            </div>
            <div className="p-4 flex justify-center gap-4 bg-gray-50">
              <button
                onClick={() => setShowWebcam(false)}
                className="px-6 py-2.5 text-sm font-semibold text-gray-600 hover:bg-gray-200 rounded-xl transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={captureWebcam}
                className="px-6 py-2.5 text-sm font-semibold text-white bg-[#0C4550] rounded-xl hover:bg-[#0C4550]/90 transition-colors"
              >
                Capture Photo
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfilePage;